var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5C9.24264 6.5 10.25 5.49264 10.25 4.25C10.25 3.00736 9.24264 2 8 2C6.75736 2 5.75 3.00736 5.75 4.25C5.75 5.49264 6.75736 6.5 8 6.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7C5.67157 7 5 7.67157 5 8.5V14H11V8.5C11 7.67157 10.3284 7 9.5 7H6.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 6.875C4.25 7.49632 3.74632 8 3.125 8C2.50368 8 2 7.49632 2 6.875C2 6.25368 2.50368 5.75 3.125 5.75C3.74632 5.75 4.25 6.25368 4.25 6.875Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 8C13.4963 8 14 7.49632 14 6.875C14 6.25368 13.4963 5.75 12.875 5.75C12.2537 5.75 11.75 6.25368 11.75 6.875C11.75 7.49632 12.2537 8 12.875 8Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 9.17157 2.67157 8.5 3.5 8.5H4.25V14H3.5C2.67157 14 2 13.3284 2 12.5V10Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.5H11.75V14H12.5C13.3284 14 14 13.3284 14 12.5V10C14 9.17157 13.3284 8.5 12.5 8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.43f07233.svg";
export { ForwardRef as ReactComponent };